/**
 * Smooth-scroll to Yotpo reviews widget when clicking the PDP review summary.
 */

function isProductTemplate() {
  const templateName = /** @type {any} */ Theme?.template?.name;
  return typeof templateName === 'string' && templateName.startsWith('product');
}

function getHeaderOffsetPx() {
  const bodyStyles = getComputedStyle(document.body);
  const headerGroupHeight = parseFloat(bodyStyles.getPropertyValue('--header-group-height'));
  if (!Number.isNaN(headerGroupHeight) && headerGroupHeight > 0) return headerGroupHeight;

  const headerHeight = parseFloat(bodyStyles.getPropertyValue('--header-height'));
  if (!Number.isNaN(headerHeight) && headerHeight > 0) return headerHeight;

  return 0;
}

/** @param {HTMLElement} element */
function scrollToElementWithOffset(element) {
  const rect = element.getBoundingClientRect();
  const offset = getHeaderOffsetPx() + 16;
  const top = rect.top + window.scrollY - offset;

  window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' });
}

/** @param {MouseEvent} event */
function onDocumentClick(event) {
  if (!isProductTemplate()) return;

  const target = /** @type {Element | null} */ (event.target instanceof Element ? event.target : null);
  if (!target) return;

  const reviewsContainer = target.closest('.product-details .reviews-container');
  if (!reviewsContainer) return;

  const yotpoWidget = document.querySelector('.yotpo-widget-instance');
  if (!yotpoWidget) return;

  // If this is inside/over an anchor, avoid navigating.
  if (target.closest('a')) {
    event.preventDefault();
  }

  // Give any lazy-loading code a tick, then scroll.
  requestAnimationFrame(() => {
    scrollToElementWithOffset(yotpoWidget);
  });
}

document.addEventListener('click', onDocumentClick, { capture: true });
